export const disableTreeNode = (node, ids) => {
  const { key, children } = node;
  // controllo se il nodo è presente nella lista dei filtri attivi
  const isNodeDisabled = ids.indexOf(key) === -1;

  // se il nodo ha figli cerco tra i figli
  if (children !== undefined && children.length > 0) {
    let foundAtLeastOneChildredAnabled = false;
    const _children = children.map(_node => {
      const treeNode = disableTreeNode(_node, ids);
      // se trovo almenu un children abilitato non devo disabilitare il padre
      if (!foundAtLeastOneChildredAnabled)
        foundAtLeastOneChildredAnabled = ids.indexOf(_node.key) !== -1;
      return treeNode;
    });
    const _node = {
      ...node,
      children: _children,
      disabled: foundAtLeastOneChildredAnabled ? false : isNodeDisabled
    };
    return _node;
  } else {
    const newNode = {
      ...node,
      disabled: isNodeDisabled
    };
    // console.log("newNode ", newNode);
    return newNode;
  }
};

export const disableMainTreeNode = (node, ids) => {
  const { key, children } = node;
  // controllo se il nodo è presente nella lista dei filtri attivi
  const isNodeDisabled = ids.indexOf(key) === -1;

  // se il nodo ha figli cerco tra i figli
  if (children !== undefined && children.length > 0) {
    let foundAtLeastOneChildredAnabled = false;
    const _children = children.map(_node => {
      const treeNode = disableTreeNode(_node, ids);
      // se trovo almenu un children abilitato non devo disabilitare il padre
      if (!foundAtLeastOneChildredAnabled)
        foundAtLeastOneChildredAnabled = ids.indexOf(_node.key) !== -1;
      return treeNode;
    });
    const _node = {
      ...node,
      children: _children,
      isDisabled: foundAtLeastOneChildredAnabled ? false : isNodeDisabled
    };
    return _node;
  } else {
    const newNode = {
      ...node,
      isDisabled: isNodeDisabled
    };
    // console.log("newNode ", newNode);
    return newNode;
  }
};

export const disableFlatNode = (node, ids) => {
  const { id } = node;
  return {
    ...node,
    disabled: ids.indexOf(id) === -1
  };
};



// WEBPACK FOOTER //
// ./src/reducers/utils/index.js